import { CrudMode, Grid, ValidationErrors, pn, useElementBreakpoints } from "@compass/core";
import { LkRole, User, UserEditResource, UserViewResource } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { BasicInfo } from "./BasicInfo";
import { DataAssignment } from "./DataAssignment";
import { MatchAssignment } from "./MatchAssignment";
import { Texting } from "./Texting";
import { UserRole } from "./UserRole";
import { Notification } from "./Notification";
import { SystemInfo } from "./SystemInfo";

export const UserPageBody = (props: {
  crudMode: CrudMode;
  user: User;
  setUser: (value: User) => void;
  viewResource: UserViewResource;
  editResource: UserEditResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, setBreakpoints, fullFieldBreakpoints } = useElementBreakpoints();
  const [selectedRole, setSelectedRole] = useState<LkRole>();
  const generationValidationErrors = props.validationErrors[pn<User>("generalValidationErrors")];

  useEffect(() => {
    const role: LkRole | undefined = props.viewResource.roles?.find((x) => x.id === props.user.roleId);
    setSelectedRole(role);
  }, [props.user.roleId, props.viewResource]);

  return (
    <Grid ref={breakpointsRef} container spacing="lg">
      <Grid item xs={fullFieldBreakpoints}>
        <BasicInfo
          crudMode={props.crudMode}
          user={props.user}
          setUser={props.setUser}
          viewResource={props.viewResource}
          editResource={props.editResource}
          validationErrors={props.validationErrors}
        />
      </Grid>

      {props.crudMode === "view" && (
        <Grid item xs={fullFieldBreakpoints}>
          <SystemInfo user={props.user} setUser={props.setUser} viewResource={props.viewResource} />
        </Grid>
      )}

      <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
        <UserRole
          crudMode={props.crudMode}
          user={props.user}
          setUser={props.setUser}
          viewResource={props.viewResource}
          editResource={props.editResource}
          validationErrors={props.validationErrors}
        />
      </Grid>

      {selectedRole?.canUseDataAssignment && (
        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
          <DataAssignment
            crudMode={props.crudMode}
            user={props.user}
            setUser={props.setUser}
            editResource={props.editResource}
            validationErrors={props.validationErrors}
            selectedRole={selectedRole}
          />
        </Grid>
      )}

      {selectedRole?.canUsePartnerAssignment && (
        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
          <MatchAssignment
            crudMode={props.crudMode}
            user={props.user}
            setUser={props.setUser}
            editResource={props.editResource}
            validationErrors={props.validationErrors}
            selectedRole={selectedRole}
          />
        </Grid>
      )}

      <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
        <Texting
          crudMode={props.crudMode}
          user={props.user}
          setUser={props.setUser}
          viewResource={props.viewResource}
          editResource={props.editResource}
          validationErrors={props.validationErrors}
          selectedRole={selectedRole}
        />
      </Grid>

      <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
        <Notification
          crudMode={props.crudMode}
          user={props.user}
          setUser={props.setUser}
          viewResource={props.viewResource}
          editResource={props.editResource}
          validationErrors={props.validationErrors}
          selectedRole={selectedRole}
        />
      </Grid>
    </Grid>
  );
};
